import { isFunction as _isFunction } from 'lodash-es'
import store from '@/store'

import { querySignStatus } from '@/views/funcPuzzle/utils/index.js'

export class signatureMethod {
  constructor({
    flowId,
    accountId,
    prescripNum,
    doctorId,
    signType,
    signUrl,
    businessType,
    response,
    beforeConfirm,
    signSuccess,
    signFail,
    eSignFail
  }) {
    this.flowId = flowId
    this.accountId = accountId
    this.prescripNum = prescripNum
    this.signUrl = signUrl
    this.doctorId = doctorId
    this.signType = signType
    this.businessType = businessType
    this.response = response

    this._timeout = null

    // 签名成功后（查询到签名结果后）
    if (_isFunction(signSuccess)) {
      this.signSuccess = signSuccess
    } else {
      this.signSuccess = null
    }

    // 签名失败，未查询到结果or查询错误or查询超时or...
    if (_isFunction(signFail)) {
      this.signFail = signFail
    } else {
      this.signFail = null
    }

    if (_isFunction(eSignFail)) {
      this.eSignFail = eSignFail
    } else {
      this.eSignFail = null
    }

    // 轮询签名之前调用（）
    if (_isFunction(beforeConfirm)) {
      this.beforeConfirm = beforeConfirm
    } else {
      this.beforeConfirm = null
    }

    this._toSign()
  }

  _toSign() {
    if (this.signType === '3' || this.signType === 3) {
      this._eSign()
    } else {
      if (
        ['26281', '27971'].includes(store.state.user.userInfos.hospitalID) &&
        [2, '2'].includes(this.signType)
      ) {
        // 26281 27971 院内签名--使用E签通
        this._eTongSign()
      } else if (['28770'].includes(store.state.user.userInfos.hospitalID)) {
        // 宁城中心院内签名--使用自己的签名小程序
        this._ncSign()
      } else {
        // 其他使用e签宝小程序
        this._eSign()
      }
    }
  }

  _eTongSign() {
    uni.navigateTo({
      url: `/subpackage/eTongSign/eTongSignWebview`,
      success: suc => {
        suc.eventChannel.emit('openSignUrl', {
          signUrl: this.signUrl
        })
      },
      events: {
        signPageDataChange: data => {
          // 走查询前的提示
          this._beforeCheckStatusModal()
        }
      }
    })
  }

  // 跳转到e签宝小程序
  _eSign() {
    wx.navigateToMiniProgram({
      appId: 'wx1cf2708c2de46337', // 上链公证签小程序APPID
      path: '/pages/index/index', // 上链公证签页面地址
      extraData: {
        requestObj: {
          // 必填，入参
          flowId: this.flowId, // 必填，签署流程id
          accountId: this.accountId, // 签署必填，账号id
          type: 'SIGN', // 非必填，业务类型：签署 SIGN（默认）
          env: 'prod' // 非必填，对接环境：线上 prod(默认）, 模拟 sml(用于对接调试阶段）
        },
        callbackObj: {
          // 非必填，回传数据：签署完成后会将此数据完整回传
          from: 'esign',
          prescripNum: this.prescripNum
        }
      },
      success: () => {
        // 去前置提示
        this._beforeCheckStatusModal()
      },
      fail: () => {
        // 调用e签宝失败
        if (_isFunction(this.eSignFail)) {
          this.eSignFail()
        }
      }
    })
  }

  // 跳转到宁城中心医院(28770)使用的签名小程序
  _ncSign() {
    // const appCode = JSON.parse(this.signUrl)?.id ?? ''
    const signUrl = JSON.parse(this.signUrl) || { id: '' }
    const appCode = signUrl.id

    // const query = `https://coss-m.isignet.cn:8778/dpscs/cossMini?appId=${appCode}&authCode=${this.response.authCode}`
    const query = `https://coss-m.isignet.cn:8778/dpscs/cossMini?appId=${appCode}&signDataId=${this.response.flowId}`
    const encode = encodeURIComponent(query)

    console.log('query', query)

    console.log('encode', encode)

    wx.navigateToMiniProgram({
      appId: 'wx3131497c4038aed7', // 签名小程序APPID
      path: `pages/welcome/welcome?q=${encode}`, // 签名页面地址
      // extraData: {
      //   query: {
      //     q: this.signUrl
      //   }
      // },
      success: () => {
        // 去前置提示
        this._beforeCheckStatusModal()
      },
      fail: e => {
        console.log('e', e)
        // 调用e签宝失败
        if (_isFunction(this.signFail)) {
          this.signFail()
        }
      }
    })
  }

  // 查询签名之前的提示
  _beforeCheckStatusModal() {
    if (_isFunction(this.beforeConfirm)) {
      this.beforeConfirm()
    } else {
      this.checkSignResult()
    }
  }

  // 为查询签名前那个方法提供的继续操作的方法
  afterCheckModel() {
    this.checkSignResult()
  }

  // toObtainState() {}

  // 递归查询签名的状态
  checkSignResult() {
    const params = Object.assign({
      hospitalID: store.state.user.userInfos.hospitalID,
      businessType: this.businessType, // 1 开方，2审核，3发药
      doctorId: this.doctorId,
      businessNo: this.prescripNum
    })
    uni.showLoading({
      title: '结果查询中',
      icon: 'none'
    })

    this.fetchSignResult(params, 0)
  }

  async fetchSignResult(querydata, times = 0) {
    console.log('querydata -- ', querydata)
    if (times === 15) {
      uni.hideLoading()
      uni.showToast({
        title: '未查询到结果',
        duration: 2000
      })

      if (_isFunction(this.signFail())) {
        this.signFail()
      }
      return
    } else {
      times++
    }

    querySignStatus(querydata)
      .then(res => {
        console.log('querySignStatus --- res', res)
        // res.code 1签署中，2签署成功，5过期，7拒签，-1异常
        if (res.code === 1 || res.code === 0 || res.code === 8) {
          clearTimeout(this._timeout)
          this._timeout = null
          this._timeout = setTimeout(() => {
            this.fetchSignResult(querydata, times)
          }, 2000)
          return
        } else if (res.code === 2 || res.code === '2') {
          uni.hideLoading()
          uni.showToast({
            title: '签名成功！',
            duration: 2000
          })
          if (_isFunction(this.signSuccess())) {
            this.signSuccess()
          }
          return
        }

        // 当值不为1时，就没在签署状态，清除计时，关闭loading
        uni.hideLoading()

        // res.code 不为1，那就该结束轮询，状态为失败或成功，并不在等待状态
        switch (res.code) {
          case 5:
            uni.showToast({
              title: '签名操作已过期',
              duration: 2000
            })
            break

          case 7:
            uni.showToast({
              title: '签名操作已拒签',
              duration: 2000
            })
            break

          case -1:
            uni.showToast({
              title: '查询签名状态异常',
              duration: 2000
            })
            break

          default:
            uni.showToast({
              title: res.codeDesc || res.message || res.data || '签名错误，请重试',
              duration: 2000
            })
            break
        }

        if (_isFunction(this.signFail())) {
          this.signFail()
        }
      })
      .catch(() => {
        uni.hideLoading()
      })
  }
}
